import styled from 'styled-components'
import { Formik } from 'formik'
import { useIntl, FormattedMessage, defineMessages } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { getUnprocessableErrors } from 'utils/error'
import { Button } from 'components/v2/Button'
import Card from '@10xLabs/react-web/components/Card'
import { Input } from 'components/Input'
import { Label } from 'components/v2/Label'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { Row } from '@10xLabs/react-web/components/Row'
import { Column } from '@10xLabs/react-web/components/Column'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { Hr } from '@10xLabs/react-web/components/Hr'
import { SelectPermissions } from 'features/Roles/components/SelectPermissions'
import { schema } from './schema'

const MainLabel = styled(Label)<TSFixMe>`
  padding: 10px 0;
  border-bottom: 1px solid #5d5c70;
  margin-bottom: 20px;
`

const messages = defineMessages({
  namePlaceholder: {
    id: 'dictionary.name',
    defaultMessage: 'Name'
  }
})

const NewCompanyRoleForm = (props: TSFixMe): TSFixMe => {
  const { values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, error, loading, isEdit } =
    props

  const intl = useIntl()

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <Card.Content noHeader>
        <Row>
          <Column width="50%">
            <Input
              id="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              placeholder={intl.formatMessage(messages.namePlaceholder)}
              touched={touched.name}
              errors={errors.name}
              label={<FormattedMessage id="dictionary.name" defaultMessage="Name" />}
            />
          </Column>
        </Row>

        <Hr />

        <Row>
          <Column>
            <MainLabel>
              <FormattedMessage id="dictionary.permissions" defaultMessage="Permissions" />
            </MainLabel>

            <div>
              <SelectPermissions
                values={values.permissionIDs}
                onChange={(values: TSFixMe): TSFixMe => {
                  setFieldValue('permissionIDs', values)
                }}
              />
            </div>
          </Column>
        </Row>
      </Card.Content>

      <Card.Footer>
        {error && (
          <div>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage
                id="companyRoles.form.error"
                defaultMessage="There was an error while saving your company role"
              />
            </ErrorMessage>
          </div>
        )}

        <Card.FooterActions>
          <Button as={NavLink} to="/company-roles" kind="cancel">
            <FormattedMessage id="dictionary.cancel" defaultMessage="Cancel" />
          </Button>

          <Button type="submit" kind="primary" loading={loading}>
            {isEdit ? (
              <FormattedMessage id="dictionary.update" defaultMessage="Update" />
            ) : (
              <FormattedMessage id="dictionary.create" defaultMessage="Create" />
            )}
          </Button>
        </Card.FooterActions>
      </Card.Footer>
    </form>
  )
}

export const NewCompanyRole = ({ companyRole = {}, isEdit, onSubmit, error, loading }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const permissions = companyRole.permissions || []

  const initialCompanyRole = {
    name: companyRole.name || '',
    permissionIDs: permissions.map(({ id }: TSFixMe): TSFixMe => id)
  }

  return (
    <Formik initialValues={initialCompanyRole} validationSchema={schema(intl)} onSubmit={onSubmit}>
      {(props): TSFixMe => {
        return <NewCompanyRoleForm {...props} error={error} loading={loading} isEdit={isEdit} />
      }}
    </Formik>
  )
}
